import type { FaireProductEntity } from "../../entity_types/product";

export const p_mynm356qt9: FaireProductEntity = {
  token: "p_mynm356qt9",
  type: "product",
  name: "Tonal Smiley Raw Edge Tee",
  brandToken: "b_9e6f6x9c2j",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/9c4b75fb1e793eaa60748ff1a231e04981ef20a7ee81296c1e18631c30df9f4b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/76d13f3bb15c50d5bf2840f285282488e3454efd47f6f726e3ca31c8baba8950.jpeg",
    "https://cdn.faire.com/fastly/a56a41c9fe1496a297fcd1c9b565e816a355d49ef291b7385e71a9913d76985a.jpeg",
    "https://cdn.faire.com/fastly/4c8e9060218fedb7250f3eb4060f7bd8f5bc25021bc1375e061a50a94b335bec.jpeg",
    "https://cdn.faire.com/fastly/c25f8baed7249290ca7ede98191b73611ad93203f14affbdda38292f578cda4e.jpeg",
    "https://cdn.faire.com/fastly/3ae0061908cd990b5dafb95607b4271c95a73bb4bb9eb4dbca880998b15422d0.jpeg",
    "https://cdn.faire.com/fastly/0daa35e5f046242eca6d693e2a1192955a1c7414826f5b2401e0056be9ad61b3.jpeg",
    "https://cdn.faire.com/fastly/b44224e37074355828d3ca032679de5dd1da6e12e87a0a822ba64cd4faa6541e.jpeg",
  ],
  priceDollars: 12.46,
  description:
    'Charming! You will make an adorable impression in this comfy top with multicolored smiley face graphic at the center chest.\n\n\n * Short Sleeve \n * Crewneck \n * Raw Edge Detail at Neckline, Sleeve Opening and Bottom \n * Front Screen Print " Smiley Face" Graphic \n * Machine Wash \n * Imported ',
  tags: [],
  msrpDollars: 24.91,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:05.889Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
